:host {
}

@keyframes stzh-loader {
  0% {
    transform: scale(0);
    left: 0px;
    opacity: 1;
  }
  12.5% {
    transform: scale(1);
  }
  25% {
    left: 0px;
  }
  37.5% {
    left: 70px;
  }
  50% {
    left: 70px;
  }
  62.5% {
    left: 140px;
  }
  75% {
    left: 140px;
    transform: scale(1);
  }
  87.5% {
    left: 140px;
    transform: scale(0);
    opacity: 1;
  }
  100% {
    left: 140px;
    opacity: 0;
  }
}

.stzh-loader {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__label {
    @include fontSize('micro');
    text-align: center;

    &:not(:empty) {
      margin-top: space('medium');
    }
  }

  &__wrapper {
    width: 200px / $loaderFactor;
    height: 40px / $loaderFactor;
  }

	&__uil {
		background: none;
		position: relative;
		width: 200px;
		height: 40px;
		transform: scale($loaderScale);
		transform-origin: top left;
	}

	&__ib {
		width: 100%;
		height: 100%;
		transform: rotate(0deg);
	}

	&__circle {
		width: 60px;
		height: 40px;
		position: absolute;
		opacity: 0;
		text-align: center;
		animation: stzh-loader 3s linear infinite;

    & > div {
      width: 40px;
      height: 40px;
      border-radius: 20px;
      margin: 0 10px;
    }

    &:nth-of-type(2n+1) > div {
      background: #0F05A0;
    }

    &:nth-of-type(2n) > div {
      background: #0F05A0;
    }

    &:nth-of-type(1) {
      animation-delay: 0s;
    }

    &:nth-of-type(2) {
      animation-delay: 0.75s;
    }

    &:nth-of-type(3) {
      animation-delay: 1.5s;
    }

    &:nth-of-type(4) {
      animation-delay: 2.25s;
    }
	}

  /* Small variant */

  &--size-small &__label {
    @include fontSize('pico');

    &:not(:empty) {
      margin-top: space('xsmall');
    }
  }

	&--size-small &__wrapper {
		width: 200px / $loaderFactor * $loaderSmallFactor;
		height: 40px / $loaderFactor * $loaderSmallFactor;
	}

  &--size-small &__uil {
		transform: scale($loaderScale * $loaderSmallFactor);
  }

  /* Hide label */

  &--hide-label &__label {
    @include visuallyhidden;
  }
}
